import React, { HTMLProps } from "react";
import cn from "classnames";
import s from "../FilterPage.module.scss";

const Preamble = ({ className, ...props }: HTMLProps<HTMLDivElement>) => (
  <div {...props} className={cn(className, s.preamble)} />
);

export default Preamble;
